import { Component } from '@angular/core';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { PriceFormatPipe } from '../../utils/pipes/price-format.pipe';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';

@Component({
  selector: 'side-order-discount-info',
  templateUrl: './side-order-discount-info.component.html',
})
export class SideOrderDiscountInfoComponent {

  public discountPrice = '';
  public discountInfo = '';
  private priceFormat: PriceFormatPipe = new PriceFormatPipe();

  constructor(
    protected commonInfo: CommonInfoService,
    private notificationProviderService: NotificationProviderService
  ) {
    this.notificationProviderService.subscribe(
      NotificationProviderTypeEnum.COMMON_INFO,
      (commonInfo: CommonInfoService) => {
        if (!commonInfo) {
          return;
        }

        this.update();
      });
  }

  update() {
    if (this.commonInfo.simCardDiscount) {
      const discountPriceFourPlus = `${this.priceFormat.transform(this.commonInfo.simCardDiscount[this.commonInfo.taxName]) +
      ' ' + this.commonInfo.priceEnding}`;
      const requiredParticipants = this.commonInfo.simCardDiscount?.requiredParticipants;

      if (this.commonInfo.isRetentionOffer) {
        this.discountInfo = `przedłużenie&nbsp;minimum ${requiredParticipants} numerów`;
        this.discountPrice = discountPriceFourPlus;
      } else {
        this.discountInfo = `zakup&nbsp;minimum ${requiredParticipants} numerów`;
        this.discountPrice = discountPriceFourPlus;
      }
    }
  }
}
